import ISO_ADA from 'assets/canvasGraphics/iso_ada.json';
import ISO_DOUGLAS from 'assets/canvasGraphics/iso_douglas.json';
import ISO_KATNISS from 'assets/canvasGraphics/iso_katniss.json';
import ISO_RUST from 'assets/canvasGraphics/iso_rust.json';
import ISO_SKILLY from 'assets/canvasGraphics/iso_skilly.json';
import ISO_ELEMENT from 'assets/canvasGraphics/iso_element.json';

import TD_ADA from 'assets/canvasGraphics/td_ada.json';
import TD_DOUGLAS from 'assets/canvasGraphics/td_douglas.json';
import TD_KATNISS from 'assets/canvasGraphics/td_katniss.json';
import TD_RUST from 'assets/canvasGraphics/td_rust.json';
import TD_SKILLY from 'assets/canvasGraphics/td_skilly.json';
import TD_ELEMENT from 'assets/canvasGraphics/td_element.json';

import UI_GENERAL from 'assets/canvasGraphics/ui_general.json';
import STD_CHARACTERS from 'assets/canvasGraphics/std_characters.json';
import STD_COMBINED from 'assets/canvasGraphics/std_combined.json';
import STD_OBJECTS from 'assets/canvasGraphics/std_objects.json';

export default function getFreecodeLazyImageData(image) {
  const data =
    UI_GENERAL[image] ||
    STD_CHARACTERS[image] ||
    STD_COMBINED[image] ||
    STD_OBJECTS[image] ||
    ISO_ELEMENT[image] ||
    TD_ELEMENT[image] ||
    ISO_ADA[image] ||
    ISO_DOUGLAS[image] ||
    ISO_KATNISS[image] ||
    ISO_RUST[image] ||
    ISO_SKILLY[image] ||
    TD_ADA[image] ||
    TD_DOUGLAS[image] ||
    TD_KATNISS[image] ||
    TD_RUST[image] ||
    TD_SKILLY[image];
  return { ...data, name: image };
}
